import { tenantSurface } from "./app-host";

/**
 * Which surface you are looking at is normally decided by the host: staff.wvcea.app
 * serves the staff app at its own root, and every link inside it is written from that
 * root. But one host can serve every surface — the demo does, and so does a tenant host
 * reached at /staff before the worker redirects it. There the app is mounted under a
 * prefix, App.tsx slices that prefix off before it routes, and the links it renders come
 * out addressed from the wrong root. Clicking Events on the demo left the staff app
 * altogether and landed in the attendee workspace.
 *
 * Only the two prefixes App.tsx actually slices are listed here. The presenter and
 * exhibitor portals are handed the whole path and link out of themselves on purpose —
 * "Open the guide" is supposed to leave.
 */
const MOUNTED_UNDER: readonly string[] = ["/staff", "/school"];

export function surfaceBasePath(
  pathname: string = typeof window === "undefined" ? "" : window.location.pathname,
  surface: string | null = typeof document === "undefined" ? null : tenantSurface(),
): string {
  // A surface host serves the app at its own root, so there is no prefix to put back.
  if (surface !== null) return "";
  return MOUNTED_UNDER.find((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)) ?? "";
}

/**
 * Only a root-relative link needs the prefix. A bare "?association=..." deliberately
 * keeps you on the page you are on, and "//host" or "https://..." is leaving anyway.
 */
export function withSurfaceBase(href: string, base: string = surfaceBasePath()): string {
  if (base === "" || !href.startsWith("/") || href.startsWith("//")) return href;
  return `${base}${href}`;
}
